module.exports = __webpack_public_path__ + "img/kirinsushiovermicroview.7ca69e87.jpg";